// extracted by mini-css-extract-plugin
export default {"container":"footer_link_container_container__Ck7p5"};